import BgQuotes from "@/assets/svgs/backgrounds/BgQuotes";
import { SuccessStoryType } from "@/shared/types/common.types";
import TestimonyCarouselCard from "./Cards/TestimonyCarouselCard";
import Carousel from "./Carousel";

export type TestimonyCarouselSectionPropType = {
  successStories: SuccessStoryType[];
  title?: string;
  countryCode?: string;
};

const TestimonyCarouselSection = ({
  successStories,
  title,
  countryCode,
}: TestimonyCarouselSectionPropType) => {
  const finalTitle = countryCode === 'IN' ? 'Why Indian creators choose Graphy' : 'Why creators choose Graphy';
  return (
    <div className="w-full flex flex-col items-center bg-transparent">
      <div className="w-full flex justify-center">
        <h2
          className="text-[32px] md:text-[48px] leading-[40px] md:leading-[56px] tracking-[-0.01em] text-[#3A3D50] text-center w-full max-w-[785px]"
        >
          {finalTitle}
        </h2>
      </div>
      <div className="w-full flex flex-col items-center mt-8 px-4 md:px-8">
        <div className="relative flex justify-center items-center w-full max-w-[785px] rounded-[20px] bg-[#F8F9FB] p-6 md:p-6 min-h-[216px]">
          <Carousel>
            {successStories.map((successStory, index) => (
              <TestimonyCarouselCard successStory={successStory} key={index} isPricingPage={true} />
            ))}
          </Carousel>
          <BgQuotes className="-z-1 pointer-events-none absolute bottom-10 right-0 sm:hidden" />
        </div>
      </div>
    </div>
  );
};

export default TestimonyCarouselSection;
